import { apiFetch } from './apiFetch';
import type {
  HugimAddonPercentRow,
  HugimAddonSettings,
  HugimPercentRow,
  HugimSettings,
  HugRole,
  ManualAdjustmentInput,
  ManualAdjustmentsResponse,
} from '@salaries/shared';

export interface HugimCourse {
  hug_key: string;
  hug_name: string;
  course_type: string | null;
  coaches: string[];
  start_date: string | null;
  end_date: string | null;
  participant_count: number;
}

export async function getHugimSettings(): Promise<HugimSettings> {
  return apiFetch<HugimSettings>('/hugim/percentages');
}

export async function upsertHugimPercent(row: HugimPercentRow): Promise<HugimSettings> {
  return apiFetch<HugimSettings>('/hugim/percentages', {
    method: 'PUT',
    body: JSON.stringify(row),
  });
}

export async function deleteHugimPercent(
  coach: number,
  hug: string,
  role: HugRole = 'primary',
): Promise<HugimSettings> {
  const qs = new URLSearchParams({ coach: String(coach), hug, role });
  return apiFetch<HugimSettings>(`/hugim/percentages?${qs.toString()}`, { method: 'DELETE' });
}

export async function listHugimCourses(): Promise<HugimCourse[]> {
  return apiFetch<HugimCourse[]>('/hugim/courses');
}

// ── מוצרים נלווים (add-ons) percentages ─────────────────────────────────────

export async function getHugimAddonSettings(): Promise<HugimAddonSettings> {
  return apiFetch<HugimAddonSettings>('/hugim/addon-percentages');
}

export async function upsertHugimAddonPercent(row: HugimAddonPercentRow): Promise<HugimAddonSettings> {
  return apiFetch<HugimAddonSettings>('/hugim/addon-percentages', {
    method: 'PUT',
    body: JSON.stringify(row),
  });
}

/** coach 0 + hug '' clears the box default; any other row falls back a level. */
export async function deleteHugimAddonPercent(
  coach: number,
  hug: string,
  role: HugRole = 'primary',
): Promise<HugimAddonSettings> {
  const qs = new URLSearchParams({ coach: String(coach), hug, role });
  return apiFetch<HugimAddonSettings>(`/hugim/addon-percentages?${qs.toString()}`, { method: 'DELETE' });
}

// ── תוספות וקיזוזים ידניים — each call saves on its own ─────────────────────

export async function getManualAdjustments(staffId: number): Promise<ManualAdjustmentsResponse> {
  return apiFetch<ManualAdjustmentsResponse>(`/hugim/manual-adjustments?staff=${staffId}`);
}

export async function createManualAdjustment(
  staffId: number,
  input: ManualAdjustmentInput,
): Promise<ManualAdjustmentsResponse> {
  return apiFetch<ManualAdjustmentsResponse>('/hugim/manual-adjustments', {
    method: 'POST',
    body: JSON.stringify({ ...input, arbox_users_boxes_id: staffId }),
  });
}

export async function updateManualAdjustment(
  id: number,
  input: Omit<ManualAdjustmentInput, 'kind'>,
): Promise<ManualAdjustmentsResponse> {
  return apiFetch<ManualAdjustmentsResponse>(`/hugim/manual-adjustments/${id}`, {
    method: 'PUT',
    body: JSON.stringify(input),
  });
}

export async function deleteManualAdjustment(id: number): Promise<ManualAdjustmentsResponse> {
  return apiFetch<ManualAdjustmentsResponse>(`/hugim/manual-adjustments/${id}`, { method: 'DELETE' });
}
